import { render, staticRenderFns } from "./PlanuriTratament.vue?vue&type=template&id=ef7aed3e&"
import script from "./PlanuriTratament.vue?vue&type=script&lang=js&"
export * from "./PlanuriTratament.vue?vue&type=script&lang=js&"
import style0 from "./PlanuriTratament.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports